export default __webpack_public_path__ + "static/media/folder-share.aca9ab35.svg";